var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPGeneralRou = function SvgPGeneralRou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 456.6,
    y: 18.6,
    width: 27,
    height: 27,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.1,19.1v26h-26v-26L483.1,19.1 M484.1,18.1h-28v28h28V18.1L484.1,18.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M467.6,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C469.1,43.2,468.5,43.8,467.6,43.8L467.6,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.5,39.6 463.7,35.8 460.8,39.6 462.6,39.6 462.6,41.4 464.7,41.4 464.7,39.6",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M480.5,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C482,43.2,481.3,43.8,480.5,43.8L480.5,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "479.4,37.7 476.5,41.4 473.7,37.7 475.5,37.7 475.5,35.8 477.5,35.8 477.5,37.7",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M479.3,28.3c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3S479.3,28.5,479.3,28.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.5,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C469,28.8,469.3,28.8,469.5,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.3,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L468.3,24.5L468.3,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.4,24.3l0.5-0.3h3l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0V24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.6,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C472.6,21.2,472.6,21.5,472.6,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,20.5L472,20.5L472,20.5L472,20.5c-0.3-0.1-0.6-0.1-0.9-0.1h-1.5c-0.3,0-0.6,0-0.8,0.1 c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L472,20.5L472,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.9,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C474.3,28.8,474.6,28.8,474.9,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.6,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L473.6,24.5L473.6,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.7,24.3l0.5-0.3h3l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0 C473.6,24.4,473.7,24.3,473.7,24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.9,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C477.9,21.2,477.9,21.5,477.9,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.3,20.5L477.3,20.5L477.3,20.5L477.3,20.5c-0.3-0.1-0.6-0.1-0.9-0.1H475 c-0.3,0-0.6,0-0.8,0.1c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L477.3,20.5L477.3,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.2,24.8h0.9c0.1,0,0.2,0,0.3,0l0,0l-0.1-0.4h-1.5l-0.3,0.2c0,0.1,0.1,0.1,0.2,0.2 C479.9,24.8,480.1,24.8,480.2,24.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.8,24.1v-1.3c0-0.1,0-0.1-0.1-0.2l-0.3,0.2v1.7l0.1,0.3l0,0c0.1,0,0.2-0.1,0.3-0.3 C481.8,24.4,481.8,24.2,481.8,24.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.6,22.5c0,0.1-0.1,0.1-0.1,0.2V24c0,0.1,0,0.3,0,0.4l0,0l0,0l0.3-0.2v-1.7L479.6,22.5 L479.6,22.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.8,21.1v1.1c0,0.1,0,0.1-0.1,0.2l-0.3-0.2v-1.5l0.1-0.3c0.1,0.1,0.2,0.1,0.2,0.2 C481.8,20.8,481.8,21,481.8,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.5,21.1v1.1c0,0.1,0,0.1,0.1,0.2l0.3-0.2v-1.5l-0.3-0.2c0,0,0,0.1-0.1,0.1 C479.5,20.8,479.5,21,479.5,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.5,20.4L481.5,20.4L481.5,20.4L481.5,20.4c-0.2,0-0.3,0-0.5,0h-0.8c-0.1,0-0.3,0-0.4,0 s-0.1,0.1-0.2,0.1l0,0l0.3,0.2h1.5L481.5,20.4L481.5,20.4z",
    fill: "#080F15"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 492.6,
    y: 18.6,
    width: 27,
    height: 27,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.1,19.1v26h-26v-26L519.1,19.1 M520.1,18.1h-28v28h28V18.1L520.1,18.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.6,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C505.1,43.2,504.5,43.8,503.6,43.8L503.6,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "502.5,39.6 499.7,35.8 496.8,39.6 498.6,39.6 498.6,41.4 500.7,41.4 500.7,39.6",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M516.5,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C518,43.2,517.3,43.8,516.5,43.8L516.5,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "515.4,37.7 512.5,41.4 509.7,37.7 511.5,37.7 511.5,35.8 513.5,35.8 513.5,37.7",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M515.3,28.3c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3S515.3,28.5,515.3,28.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.5,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C505,28.8,505.3,28.8,505.5,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.3,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L504.3,24.5L504.3,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.4,24.3l0.5-0.3h3l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0V24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.6,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C508.6,21.2,508.6,21.5,508.6,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508,20.5L508,20.5L508,20.5L508,20.5c-0.3-0.1-0.6-0.1-0.9-0.1h-1.5c-0.3,0-0.6,0-0.8,0.1 c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L508,20.5L508,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.9,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C510.3,28.8,510.6,28.8,510.9,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.6,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L509.6,24.5L509.6,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.7,24.3l0.5-0.3h2.9l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0 C509.6,24.4,509.7,24.3,509.7,24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.9,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C513.9,21.2,513.9,21.5,513.9,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.3,20.5L513.3,20.5L513.3,20.5L513.3,20.5c-0.3-0.1-0.6-0.1-0.9-0.1h-1.5 c-0.3,0-0.6,0-0.8,0.1c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L513.3,20.5L513.3,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.2,24.8h0.9c0.1,0,0.2,0,0.3,0l0,0l-0.1-0.4h-1.5l-0.3,0.2c0,0.1,0.1,0.1,0.2,0.2 C515.9,24.8,516.1,24.8,516.2,24.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,24.1v-1.3c0-0.1,0-0.1-0.1-0.2l-0.3,0.2v1.7l0.1,0.3l0,0c0.1,0,0.2-0.1,0.3-0.3 S517.8,24.2,517.8,24.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.6,22.5c0,0.1-0.1,0.1-0.1,0.2V24c0,0.1,0,0.3,0,0.4l0,0l0,0l0.3-0.2v-1.7 C515.9,22.7,515.6,22.5,515.6,22.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.8,21.1v1.1c0,0.1,0,0.1-0.1,0.2l-0.3-0.2v-1.5l0.1-0.3c0.1,0.1,0.2,0.1,0.2,0.2 C517.8,20.8,517.8,21,517.8,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5,21.1v1.1c0,0.1,0,0.1,0.1,0.2l0.3-0.2v-1.5l-0.3-0.2c0,0,0,0.1-0.1,0.1 C515.5,20.8,515.5,21,515.5,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.5,20.4L517.5,20.4L517.5,20.4L517.5,20.4c-0.2,0-0.3,0-0.5,0h-0.8c-0.2,0-0.3,0-0.4,0 c-0.1,0-0.1,0.1-0.2,0.1l0,0l0.3,0.2h1.5L517.5,20.4L517.5,20.4z",
    fill: "#080F15"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 528.6,
    y: 18.6,
    width: 27,
    height: 27,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.1,19.1v26h-26v-26L555.1,19.1 M556.1,18.1h-28v28h28V18.1L556.1,18.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M539.6,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C541.1,43.2,540.5,43.8,539.6,43.8L539.6,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "538.5,39.6 535.7,35.8 532.8,39.6 534.7,39.6 534.7,41.4 536.7,41.4 536.7,39.6",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M552.5,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C554,43.2,553.3,43.8,552.5,43.8L552.5,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "551.4,37.7 548.5,41.4 545.7,37.7 547.5,37.7 547.5,35.8 549.5,35.8 549.5,37.7",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M551.3,28.3c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3S551.3,28.5,551.3,28.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.5,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C541,28.8,541.3,28.8,541.5,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.3,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L540.3,24.5L540.3,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.4,24.3l0.5-0.3h3l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0V24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.6,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C544.6,21.2,544.6,21.5,544.6,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,20.5L544,20.5L544,20.5L544,20.5c-0.3-0.1-0.6-0.1-0.9-0.1h-1.5c-0.3,0-0.6,0-0.8,0.1 c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L544,20.5L544,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.8,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C546.3,28.8,546.6,28.8,546.8,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.6,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L545.6,24.5L545.6,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.7,24.3l0.5-0.3h3l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0 C545.6,24.4,545.7,24.3,545.7,24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.9,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C549.9,21.2,549.9,21.5,549.9,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.3,20.5L549.3,20.5L549.3,20.5L549.3,20.5c-0.3-0.1-0.6-0.1-0.9-0.1h-1.5 c-0.3,0-0.6,0-0.8,0.1c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L549.3,20.5L549.3,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.2,24.8h0.9c0.1,0,0.2,0,0.3,0l0,0l-0.1-0.4h-1.5l-0.3,0.2c0,0.1,0.1,0.1,0.2,0.2 C551.9,24.8,552.1,24.8,552.2,24.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.8,24.1v-1.3c0-0.1,0-0.1-0.1-0.2l-0.3,0.2v1.7l0.1,0.3l0,0c0.1,0,0.2-0.1,0.3-0.3 S553.8,24.2,553.8,24.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.6,22.5c0,0.1-0.1,0.1-0.1,0.2V24c0,0.1,0,0.3,0,0.4l0,0l0,0l0.3-0.2v-1.7 C551.9,22.7,551.6,22.5,551.6,22.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.8,21.1v1.1c0,0.1,0,0.1-0.1,0.2l-0.3-0.2v-1.5l0.1-0.3c0.1,0.1,0.2,0.1,0.2,0.2 C553.8,20.8,553.8,21,553.8,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.5,21.1v1.1c0,0.1,0,0.1,0.1,0.2l0.3-0.2v-1.5l-0.3-0.2c0,0,0,0.1-0.1,0.1 C551.5,20.8,551.5,21,551.5,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.5,20.4L553.5,20.4L553.5,20.4L553.5,20.4c-0.2,0-0.3,0-0.5,0h-0.8c-0.2,0-0.3,0-0.4,0 c-0.1,0-0.1,0.1-0.2,0.1l0,0l0.3,0.2h1.5L553.5,20.4L553.5,20.4z",
    fill: "#080F15"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 564.6,
    y: 18.6,
    width: 27,
    height: 27,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.1,19.1v26h-26v-26L591.1,19.1 M592.1,18.1h-28v28h28V18.1L592.1,18.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M575.6,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C577.1,43.2,576.5,43.8,575.6,43.8L575.6,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "574.5,39.6 571.7,35.8 568.8,39.6 570.7,39.6 570.7,41.4 572.7,41.4 572.7,39.6",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M588.5,43.8h-7.9c-0.9,0-1.5-0.7-1.5-1.5v-7.2c0-0.9,0.8-1.7,1.7-1.7h7.6c0.9,0,1.7,0.8,1.7,1.7v7.2 C590,43.2,589.3,43.8,588.5,43.8L588.5,43.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "587.4,37.7 584.5,41.4 581.7,37.7 583.5,37.7 583.5,35.8 585.5,35.8 585.5,37.7",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M587.3,28.3c0-0.2-0.1-0.3-0.3-0.3s-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3S587.3,28.5,587.3,28.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.5,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C577,28.8,577.3,28.8,577.5,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.3,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L576.3,24.5L576.3,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.4,24.3l0.5-0.3h3l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0V24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.6,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C580.6,21.2,580.6,21.5,580.6,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580,20.5L580,20.5L580,20.5L580,20.5c-0.3-0.1-0.6-0.1-0.9-0.1h-1.5c-0.3,0-0.6,0-0.8,0.1 c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L580,20.5L580,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.8,28.8h1.7c0.2,0,0.5,0,0.7,0l0,0l-0.1-0.7h-2.9l-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.3 C582.3,28.8,582.6,28.8,582.8,28.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.6,24.5c-0.1,0.1-0.1,0.3-0.1,0.4v2.5c0,0.3,0,0.5,0.1,0.8v0.1l0,0l0.6-0.3v-3.2 L581.6,24.5L581.6,24.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.7,24.3l0.5-0.3h3l0.5,0.3l0,0v0.1l-0.5,0.3h-3l-0.5-0.3l0,0 C581.6,24.4,581.7,24.3,581.7,24.3",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.9,21.8v2.1c0,0.1,0,0.3-0.1,0.4l-0.6-0.4V21l0.2-0.6c0.2,0.1,0.3,0.3,0.4,0.5 C585.9,21.2,585.9,21.5,585.9,21.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.3,20.5L585.3,20.5L585.3,20.5L585.3,20.5c-0.3-0.1-0.6-0.1-0.9-0.1h-1.5 c-0.3,0-0.6,0-0.8,0.1c-0.1,0.1-0.3,0.1-0.4,0.3l0,0l0.6,0.3h2.8L585.3,20.5L585.3,20.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.2,24.8h0.9c0.1,0,0.2,0,0.3,0l0,0l-0.1-0.4h-1.5l-0.3,0.2c0,0.1,0.1,0.1,0.2,0.2 C587.9,24.8,588.1,24.8,588.2,24.8",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.8,24.1v-1.3c0-0.1,0-0.1-0.1-0.2l-0.3,0.2v1.7l0.1,0.3l0,0c0.1,0,0.2-0.1,0.3-0.3 S589.8,24.2,589.8,24.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.6,22.5c0,0.1-0.1,0.1-0.1,0.2V24c0,0.1,0,0.3,0,0.4l0,0l0,0l0.3-0.2v-1.7 C587.9,22.7,587.6,22.5,587.6,22.5z",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.8,21.1v1.1c0,0.1,0,0.1-0.1,0.2l-0.3-0.2v-1.5l0.1-0.3c0.1,0.1,0.2,0.1,0.2,0.2 C589.8,20.8,589.8,21,589.8,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.5,21.1v1.1c0,0.1,0,0.1,0.1,0.2l0.3-0.2v-1.5l-0.3-0.2c0,0,0,0.1-0.1,0.1 C587.5,20.8,587.5,21,587.5,21.1",
    fill: "#080F15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.5,20.4L589.5,20.4L589.5,20.4L589.5,20.4c-0.2,0-0.3,0-0.5,0h-0.8c-0.2,0-0.3,0-0.4,0 c-0.1,0-0.1,0.1-0.2,0.1l0,0l0.3,0.2h1.5L589.5,20.4L589.5,20.4z",
    fill: "#080F15"
  }))))));
};
export default SvgPGeneralRou;